import styled from "styled-components";

const Footer = styled.div`
  width: 100%;
  min-height: 50px;
  position: relative;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  > * {
    margin: 0 10px;
  }
`;

export const PageFooter = () => {
  return <Footer></Footer>;
};
